import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { getToken, clearAuth } from '@/utils/auth'

Vue.use(Router)

// 所有页面路由 - 都放在 Layout 组件下
export const constantRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/index'),
        hidden: true
    },
    {
        path: '/',
        component: () => import('@/components/Layout/index'),
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: () => import('@/views/dashboard/index'),
                meta: { title: '数据看板', icon: 'el-icon-data-line' }
            },
            {
                path: 'user',
                name: 'User',
                component: () => import('@/views/user/index'),
                meta: { title: '用户管理', icon: 'el-icon-user' }
            },
            {
                path: 'role',
                name: 'Role',
                component: () => import('@/views/role/index'),
                meta: { title: '角色管理', icon: 'el-icon-s-custom' }
            },
            {
                path: 'dept',
                name: 'Dept',
                component: () => import('@/views/dept/index'),
                meta: { title: '部门管理', icon: 'el-icon-office-building' }
            },
            {
                path: 'post',
                name: 'Post',
                component: () => import('@/views/post/index'),
                meta: { title: '岗位管理', icon: 'el-icon-s-cooperation' }
            },
            {
                path: 'document',
                name: 'Document',
                component: () => import('@/views/document/index'),
                meta: { title: '资料管理', icon: 'el-icon-document' }
            },
            {
                path: 'log/operation',
                name: 'OperationLog',
                component: () => import('@/views/log/operation'),
                meta: { title: '操作日志', icon: 'el-icon-document-copy' }
            },
            {
                path: 'log/login',
                name: 'LoginLog',
                component: () => import('@/views/log/login'),
                meta: { title: '登录日志', icon: 'el-icon-reading' }
            },
            {
                path: 'profile',
                name: 'Profile',
                component: () => import('@/views/profile/index'),
                meta: { title: '个人中心', icon: 'el-icon-user' }
            },
            {
                path: 'company',
                name: 'Company',
                component: () => import('@/views/company/index'),
                meta: { title: '公司管理', icon: 'el-icon-office-building' }
            },
            {
                path: 'region',
                name: 'Region',
                component: () => import('@/views/region/index'),
                meta: { title: '地区管理', icon: 'el-icon-location' }
            },
            {
                path: 'project',
                name: 'Project',
                component: () => import('@/views/project/index'),
                meta: { title: '项目管理', icon: 'el-icon-document-copy', permission: 'project:list' }
            },
            {
                path: 'dataAuth',
                name: 'DataAuth',
                component: () => import('@/views/dataAuth/index'),
                meta: { title: '数据授权', icon: 'el-icon-lock', permission: 'data:auth:list' }
            },
            {
                path: 'project/dashboard',
                name: 'ProjectStatistics',
                component: () => import('@/views/project/dashboard'),
                meta: { title: '项目智析', permission: 'project:statistics' }
            },
            {
                path: 'project/analysis',
                name: 'ProjectAnalysis',
                component: () => import('@/views/project/analysis'),
                meta: { title: '项目统计', permission: 'project:analysis' }
            },
            {
                path: 'project/subcontractAnalysis',
                name: 'SubcontractAnalysis',
                component: () => import('@/views/project/subcontractAnalysis'),
                meta: { title: '分包统计', permission: 'project:subcontract:statistics' }
            },
            {
                path: '/project/subcontract/:projectId',
                name: 'SubcontractManage',
                component: () => import('@/views/project/components/SubcontractManage.vue'),
                hidden: true,
                meta: {
                    title: '分包管理',
                    activeMenu: '/project'
                }
            },
            {
                path: '/notification',
                name: 'Notification',
                component: () => import('@/views/notification/index.vue'),
                meta: { title: '消息中心', permission: 'notification:list' }
            },

            // ==================== 设备中心路由 ====================
            {
                path: 'device/asset',
                name: 'DeviceAsset',
                component: () => import('@/views/device/asset/index'),
                meta: { title: '设备台账', permission: 'device:asset:list' }
            },
            {
                path: 'device/asset/add',
                name: 'DeviceAssetAdd',
                component: () => import('@/views/device/asset/add'),
                meta: {
                    title: '新增设备',
                    permission: 'device:asset:add',
                    activeMenu: '/device/asset'
                }
            },
            {
                path: 'device/asset/edit',
                name: 'DeviceAssetEdit',
                component: () => import('@/views/device/asset/edit'),
                meta: {
                    title: '编辑设备',
                    permission: 'device:asset:edit',
                    activeMenu: '/device/asset'
                }
            },
            {
                path: 'device/outbound/apply',
                name: 'DeviceOutboundApply',
                component: () => import('@/views/device/outbound/apply/index'),
                meta: { title: '出库申请', permission: 'device:outbound:apply' }
            },
            {
                path: 'device/outbound/apply/add',
                name: 'DeviceOutboundApplyAdd',
                component: () => import('@/views/device/outbound/apply/add'),
                meta: {
                    title: '新增出库申请',
                    permission: 'device:outbound:apply',
                    activeMenu: '/device/outbound/apply'
                }
            },
            {
                path: 'device/outbound/confirm',
                name: 'DeviceOutboundConfirm',
                component: () => import('@/views/device/outbound/confirm/index'),
                meta: { title: '库管确认', permission: 'device:outbound:confirm' }
            },
            {
                path: 'device/outbound/scene',
                name: 'DeviceOutboundScene',
                component: () => import('@/views/device/outbound/scene/index'),
                meta: { title: '到场确认', permission: 'device:outbound:scene_confirm' }
            },
            {
                path: 'device/return',
                name: 'DeviceReturn',
                component: () => import('@/views/device/return/index'),
                meta: { title: '设备归还', permission: 'device:outbound:return' }
            },
            {
                path: 'device/outbound/detail',
                name: 'DeviceOutboundDetail',
                component: () => import('@/views/device/outbound/detail'),
                meta: {
                    title: '出库单详情',
                    permission: ['device:outbound:apply', 'device:outbound:confirm', 'device:outbound:scene_confirm', 'device:outbound:return']
                }
            },

            // ==================== 合思相关路由 ====================
            {
                path: 'hesi/project',
                name: 'HesiProject',
                component: () => import('@/views/hesi/project.vue'),
                meta: { title: '合思项目', icon: 'el-icon-data-board' }
            },
// ==================== 合思相关路由 ====================
            {
                path: 'hesi/project',
                name: 'HesiProject',
                component: () => import('@/views/hesi/project.vue'),
                meta: { title: '合思项目', icon: 'el-icon-data-board' }
            },
            {
                path: 'hesi/payment',
                name: 'HesiPayment',
                component: () => import('@/views/hesi/payment.vue'),
                meta: { title: '付款单' }
            },
            {
                path: 'hesi/expense',
                name: 'HesiExpense',
                component: () => import('@/views/hesi/expense.vue'),
                meta: { title: '报销单' }
            },
            {
                path: 'hesi/receiptOrder',
                name: 'HesiReceiptOrder',
                component: () => import('@/views/hesi/receiptOrder.vue'),
                meta: { title: '收款单' }
            },
            {
                path: 'hesi/custom',
                name: 'HesiCustom',
                component: () => import('@/views/hesi/custom.vue'),
                meta: { title: '通用审批单' }
            },
            {
                path: 'hesi/template',
                name: 'HesiTemplate',
                component: () => import('@/views/hesi/template.vue'),
                meta: { title: '合思单据模板' }
            },
            {
                path: 'hesi/sync',
                name: 'HesiSync',
                component: () => import('@/views/hesi/sync.vue'),
                meta: { title: '合思数据同步', icon: 'el-icon-refresh' }
            },
            {
                path: 'hesi/salesReceipt',
                name: 'HesiSalesReceipt',
                component: () => import('@/views/hesi/salesReceipt.vue'),
                meta: { title: '销售回款单' }
            },
            {
                path: 'hesi/template',
                name: 'HesiTemplate',
                component: () => import('@/views/hesi/template.vue'),
                meta: { title: '合思单据模板' }
            },
            {
                path: 'hesi/sync',
                name: 'HesiSync',
                component: () => import('@/views/hesi/sync.vue'),
                meta: { title: '合思数据同步', icon: 'el-icon-refresh' }
            },
            {
                path: 'hesi/salesReceipt',
                name: 'HesiSalesReceipt',
                component: () => import('@/views/hesi/salesReceipt.vue'),
                meta: { title: '销售回款单' }
            },
            {
                path: 'hesi/corporatePayment',
                name: 'HesiCorporatePayment',
                component: () => import('@/views/hesi/corporatePayment.vue'),
                meta: { title: '对公付款单' }
            }
        ]
    }
]

const router = new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

// 防止重复请求的标志
let isFetchingUserInfo = false
let isNavigating = false
// 白名单（不需要登录的页面）
const whiteList = ['/login']

// 路由守卫：刷新时重新获取用户信息
router.beforeEach(async (to, from, next) => {
    const savedUser = localStorage.getItem('ShareWin-User')
    if (savedUser && !store.state.user.user) {
        try {
            const user = JSON.parse(savedUser)
            store.commit('user/SET_USER', user)
        } catch(e) {}
    }

    if (store.state.user.user && !store.state.user.user.realName) {
        const savedUser2 = localStorage.getItem('ShareWin-User')
        if (savedUser2) {
            try {
                const fullUser = JSON.parse(savedUser2)
                if (fullUser.realName) {
                    store.commit('user/SET_USER', fullUser)
                }
            } catch(e) {}
        }
    }

    if (isNavigating) {
        return
    }

    const token = getToken()

    if (token) {
        if (to.path === '/login') {
            isNavigating = true
            next({ path: '/' })
            isNavigating = false
            return
        }

        let userInfo = store.getters.user
        let menus = store.getters.menus

        if (!userInfo || !userInfo.id) {
            const savedUser = localStorage.getItem('ShareWin-User')
            if (savedUser) {
                try {
                    userInfo = JSON.parse(savedUser)
                    store.commit('user/SET_USER', userInfo)
                } catch(e) {}
            }
        }

        if (!menus || menus.length === 0) {
            const savedMenus = localStorage.getItem('ShareWin-Menus')
            if (savedMenus) {
                try {
                    menus = JSON.parse(savedMenus)
                    store.commit('user/SET_MENUS', menus)
                } catch(e) {}
            }
        }

        let permissions = store.getters.permissions
        if (!permissions || permissions.length === 0) {
            const savedPermissions = localStorage.getItem('ShareWin-Permissions')
            if (savedPermissions) {
                try {
                    permissions = JSON.parse(savedPermissions)
                    store.commit('user/SET_PERMISSIONS', permissions)
                } catch(e) {}
            }
        }

        const needRefresh = !userInfo || !userInfo.id || !menus || menus.length === 0

        if (!needRefresh) {
            isNavigating = false
            next()
            return
        }

        if (isFetchingUserInfo) {
            const checkInterval = setInterval(() => {
                if (!isFetchingUserInfo) {
                    clearInterval(checkInterval)
                    isNavigating = false
                    next()
                }
            }, 50)
            return
        }

        try {
            isFetchingUserInfo = true
            isNavigating = true
            await store.dispatch('user/getUserInfo')
            isFetchingUserInfo = false
            next()
            isNavigating = false
        } catch (error) {
            isFetchingUserInfo = false
            isNavigating = false

            const finalUser = store.getters.user
            const finalMenus = store.getters.menus
            if (finalUser && finalUser.id && finalMenus && finalMenus.length > 0) {
                next()
                return
            }

            const cachedUser = localStorage.getItem('ShareWin-User')
            const cachedMenus = localStorage.getItem('ShareWin-Menus')
            if (cachedUser && cachedMenus) {
                try {
                    const user = JSON.parse(cachedUser)
                    const menus = JSON.parse(cachedMenus)
                    store.commit('user/SET_USER', user)
                    store.commit('user/SET_MENUS', menus)
                    next()
                    return
                } catch(e) {}
            }

            clearAuth()
            await store.dispatch('user/logout').catch(() => {})
            setTimeout(() => {
                next({ path: '/login', query: { redirect: to.fullPath } })
            }, 100)
        }
    } else {
        if (whiteList.includes(to.path)) {
            isNavigating = false
            next()
        } else {
            isNavigating = false
            next({ path: '/login', query: { redirect: to.fullPath } })
        }
    }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name === 'NavigationDuplicated' ||
            err.message?.includes('Navigation cancelled') ||
            err.message?.includes('Navigating to current location')) {
            return err
        }
        throw err
    })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name === 'NavigationDuplicated' ||
            err.message?.includes('Navigation cancelled') ||
            err.message?.includes('Navigating to current location')) {
            return err
        }
        throw err
    })
}

export default router